import axios from '../../plugins/axios'

export const createDiagnoseOT = ({}, data) => {
  // eslint-disable-line
  const apiAddress = '/api/diagnostico/'
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .post(apiAddress, data, config)
    .then((response) => response)
    .catch((error) => error.response)
}

export const createPreDiagnosticOT = ({}, data) => {
  // eslint-disable-line
  const apiAddress = '/api/diagnostico/pre-diagnostico'
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .post(apiAddress, data, config)
    .then((response) => response)
    .catch((error) => error.response)
}

export const rejectDiagnostic = ({}, data) => {
  // eslint-disable-line
  const apiAddress = '/api/diagnostico/reject-diagnostic'
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .post(apiAddress, data, config)
    .then((response) => response)
    .catch((error) => error.response)
}

// DAT01 - Aprobar diagnóstico (guarda fecha de aprobación)
export const approveDiagnoseOT = ({}, { diagnosticoId, data }) => {
  // eslint-disable-line
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .post(`/api/diagnostico/${diagnosticoId}/approve/`, data, config)
    .then((response) => response)
    .catch((error) => error.response)
}

export const updateDiagnoseOT = ({ commit }, data) => {
  // eslint-disable-line
  let apiAddress = `/api/diagnostico/${data.id}`
  console.log(data.email)
  if (data.email) {
    apiAddress += '?email=true'
  }
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .put(apiAddress, data, config)
    .then((response) => {
      const diagnostic = response.data
      commit('SET_DIAGNOSTIC', { diagnostic })
      return response
    })
    .catch((error) => error.response)
}

// IA01 - Sugerir texto de solución con IA
export const generarSolucionIA = ({}, diagnosticoId) => {
  // eslint-disable-line
  const apiAddress = `/api/diagnostico/${diagnosticoId}/generar-solucion/`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .post(apiAddress, {}, config)
    .then((response) => response)
    .catch((error) => error.response)
}

// eslint-disable-next-line
export const generatePdf = ({ commit }, id) => {
  const url = `/api/diagnostico/cliente_pdf/${id}`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .post(url, '', config)
    .then((response) => response)
    .catch((error) => error.response)
}

export const getLastDiagnostic = ({ commit }, id) => {
  //eslint-disable-line
  if (!id) {
    commit('SET_DIAGNOSTIC', { diagnostic: null })
    return
  }
  const url = `/api/diagnostico/${id}`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .get(url, config)
    .then((response) => {
      const diagnostic = response.data
      commit('SET_DIAGNOSTIC', { diagnostic })
    })
    .catch((error) => error.response)
}

export const showDiagnosticForm = ({ commit }, _showDiagnosticForm) => {
  //eslint-disable-line
  commit('SHOW_DIAGNOSTIC_FORM', { _showDiagnosticForm })
}

export const askParts = ({}, { otId, parts }) => {
  //   const apiAddress = '/api/bodega/partes/solicitud';
  const apiAddress = `/api/orden/${otId}/transiciones/solicitar_partes`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .post(apiAddress, parts, config)
    .then((response) => response)
    .catch((error) => error.response)
}

export const cancelPart = ({}, { otId, parte_solicitada_id, razon }) => {
  const apiAddress = `/api/orden/${otId}/transiciones/cancelar_solicitud_parte`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  const data = {
    parte_solicitada_id,
    razon,
  }
  return axios
    .post(apiAddress, data, config)
    .then((response) => response)
    .catch((error) => error.response)
}

export const markDateArrival = (
  {},
  { ot_id, solicitud_id, fecha_estimada }
) => {
  const apiAddress = `/api/bodega/marcar_llegada_estimada`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  const data = {
    ot_id,
    solicitud_id,
    fecha_estimada,
  }
  return axios
    .post(apiAddress, data, config)
    .then((response) => response)
    .catch((error) => error.response)
}

export const updateRequests = ({}, data) => {
  const apiAddress = '/api/bodega/partes/solicitud'
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .put(apiAddress, data, config)
    .then((response) => response)
    .catch((error) => error.response)
}

export const searchByPartNumber = ({}, { partNumber, shortQuery = false }) => {
  let apiAddress = `api/bodega/partes?search=${partNumber}`
  if (shortQuery) {
    apiAddress += '&short_query=true'
  }
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => response)
}

export const searchPartsByState = ({ commit }, { state }) => {
  const apiAddress = `api/bodega/partes/list?state=${state}`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => {
    const filteredParts = response.data
    commit('SET_FILTERED_PARTS', { filteredParts })
  })
}

export const savePiezasSugeridas = ({}, { otId, partes }) => {
  // eslint-disable-line
  const apiAddress = `/api/orden/${otId}/piezas_sugeridas`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .post(apiAddress, { partes }, config)
    .then((response) => response)
    .catch((error) => error.response)
}

export const getPiezasSugeridas = ({}, otId) => {
  // eslint-disable-line
  const apiAddress = `/api/orden/${otId}/piezas_sugeridas`
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .get(apiAddress, config)
    .then((response) => response)
    .catch((error) => error.response)
}

export const PartsInOTbyState = (
  {},
  { partNumber, state, page = 1, pageSize = 5 }
) => {
  const apiAddress = `api/bodega/partes/estado?part_number=${partNumber}&estado=${state}&page=${page}&page_size=${pageSize}`

  console.log('API call URL:', apiAddress)
  console.log('Parameters:', { partNumber, state, page, pageSize })

  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios.get(apiAddress, config).then((response) => {
    const partsInOT = response.data
    console.log('API Response data:', partsInOT)
    return partsInOT // Retornamos los datos directamente
  })
}

export const getServiciosSeleccionables = ({}) => {
  const apiAddress =
    '/api/oportunidadventa/listar-servicios?seleccionable_en_ot=true'
  const { key } = JSON.parse(localStorage.getItem('user'))
  const config = {
    headers: { Authorization: `Token ${key}` },
  }
  return axios
    .get(apiAddress, config)
    .then((response) => response)
    .catch((error) => error.response)
}
